
const FilterFun = () => {

    const items = [
        {
            title: "All"
        },
        {
            title: "Travel"
        },
        {
            title: "Architecture"
        },
        {
            title: "Style"
        },
        {
            title: "Sports"
        },
        {
            title: "Food"
        },
        {
            title: "Art"
        },
        {
            title: "Beauty"
        },
        {
            title: "Music"
        },
        {
            title: "Humor"
        },
        {
            title: "Fitness"
        },
    ]
    
    return { items }
}

export default FilterFun
